module.exports = __webpack_public_path__ + "static/media/obxLogo3x.d29f2aa8.png";